<template>
  <div id="member">
    <!-- tab栏 -->
    <div class="tab">
      <ul>
        <li
          v-for="(item, index) in arrowList"
          :key="index"
          :class="{ active: tabIndex == index }"
          @click="activeclick(index)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="crumbs">
        <span>首页</span>
        <img src="../../../assets/htImg/icon_you.png" alt />
        <span>{{ arrow }}</span>
      </div>
    </div>
    <div class="whole">
      <!-- <management v-if="tabIndex == 0" />
      <special v-if="tabIndex == 1" />
      <organization v-if="tabIndex == 2" /> -->
      <keep-alive>
        <component :is="common" :tabIndex="tabIndex" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import management from "../management/management";
import special from "../special/special";
import organization from "../organization/organization";

export default {
  components: {
    management,
    special,
    organization,
  },
  data() {
    return {
      arrow: "会员列表",
      arrowList: ["会员列表", "专委会列表", "会员机构列表"],
      tabIndex: 0,
      common: "management",
      tableList: [],
    };
  },
  created() {
    if (this.$route.query.id) {
      sessionStorage.setItem("tabNum", 1);
      this.tabIndex = this.$route.query.id;
      if (this.tabIndex == 0) {
        this.common = "management";
      } else if(this.tabIndex == 1){
        this.common = "special";
      }else{
        this.common = "organization";
      }
    }
  },
  methods: {
    activeclick(index) {
      this.tabIndex = index;
      switch (this.tabIndex) {
        case 0:
          this.arrow = "会员列表";
          this.common = "management";
          break;
        case 1:
          this.arrow = "专委会列表";
          this.common = "special";
          break;
        case 2:
          this.arrow = "会员机构列表";
          this.common = "organization";
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="less">
#member {
  width: 90%;
  height: 900px;
  background-color: #fff;
  .tab {
    background-color: #f7f7f7;
    display: flex;
    justify-content: space-between;
    ul {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      li {
        background-color: #e2e1e6;
        width: 154px;
        height: 43px;
        font-size: 20px;
        font-weight: 600;
        color: #343434;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
        margin-right: 7px;
      }
      .active {
        width: 174px;
        height: 55px;
        background-color: #ffffff;
        font-size: 26px;
        font-weight: bold;
        line-height: 71px;
      }
    }
    .crumbs {
      display: flex;
      align-items: center;
      img {
        width: 30px;
        height: 30px;
      }
      span {
        display: inline-block;
        color: #606062;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .whole {
    width: 100%;
    margin-bottom: 30px;
    overflow: hidden;
    background-color: #ffffff;
  }
}
</style>
